module.exports = "<div class=\"button_container\">\n  <p class=\"success\">{{data.failPage}}</p>\n  <button (click)=\"logout()\" class=\"btn\"><span>На головну</span></button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/src/app/payment/paymentFail.component.html
// module id = ../../../../../src/app/payment/paymentFail.component.html
// module chunks = 0